// validateRequiredFields — pure per-type required-field validation.
//
// Extracted VERBATIM from `components/AddEventForm.js` (`handleSave`'s
// validation block) as part of the behavior-preserving refactor (issue #240).
// Given the active `eventType` and the current `formData`, it returns the
// errors map the source built: a `{ [field]: 'This field is required' }` object
// containing exactly the required fields of THAT type that are blank. An empty
// returned object means validation passed (the source gates on
// `Object.keys(errors).length > 0`). Only the active type's fields are checked —
// no foreign-type field can leak — because the field list comes solely from
// `REQUIRED_FIELDS[eventType]`.
//
// Totality mirrors the source EXACTLY:
//   - `REQUIRED_FIELDS[eventType] || []` — an unrecognized/missing type yields no
//     required fields and therefore an empty errors map (validation passes), just
//     as in the source.
//   - The blank test is `!formData[field] || formData[field].trim() === ''`,
//     copied verbatim. The source did NOT guard `formData` or coerce non-string
//     values here (the form's required fields are all string inputs), so NO
//     extra guard is added; the error message string is identical.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

import REQUIRED_FIELDS from './requiredFields.js';

/**
 * Validate the required fields for the given event type.
 *
 * @param {string} eventType - The active event type (keys REQUIRED_FIELDS).
 * @param {Object} formData - The current form values.
 * @returns {Object} Map of blank-required-field name → 'This field is required'
 *                   (empty object when all required fields are present).
 */
export function validateRequiredFields(eventType, formData) {
  const requiredFields = REQUIRED_FIELDS[eventType] || [];
  const errors = {};
  requiredFields.forEach(field => {
    if (!formData[field] || formData[field].trim() === '') {
      errors[field] = 'This field is required';
    }
  });
  return errors;
}

export default validateRequiredFields;
